import {
    FETCH_PROCEDURE_LOOKUP_REQUEST,
    FETCH_PROCEDURE_LOOKUP_SUCCESS,
    FETCH_PROCEDURE_LOOKUP_FAILURE,
  } from "./FetchProcedureLookupTypes";
  
  const initialState = {
    loading: false,
    procedureLookup: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PROCEDURE_LOOKUP_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_PROCEDURE_LOOKUP_SUCCESS:
        return {
          loading: false,
          procedureLookup: action.payload,
          error: "",
        };
      case FETCH_PROCEDURE_LOOKUP_FAILURE:
        return {
          loading: false,
          procedureLookup: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  